module.exports = __webpack_public_path__ + "img/hut8.6ffce3c6.png";